var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Footer-badges"},_vm._l((_vm.badges),function(badge,key){return _c('a',{key:key,attrs:{"href":badge.url}},[_c('img',{attrs:{"src":_vm.badgeBaseUrl + badge.image,"alt":badge.altText}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }